// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBusinessUnitByPostalCodeRequestModel from '../../model/get-business-unit-by-postal-code-request-model';
import GetBusinessUnitByPostalCodeRequestDTO from '../dto/get-business-unit-by-postal-code-request-dto';
import dtoSchema from '../schemas/get-business-unit-by-postal-code-request-schema';

export default abstract class GetBusinessUnitByPostalCodeRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBusinessUnitByPostalCodeRequestDTO>) {
    super();
    if (data) {
      this.postalCode = data.postalCode;
      this.postalCodeAddition = data.postalCodeAddition;
    }
  }
  /**
  */
  postalCode?: string;
  /**
  */
  postalCodeAddition?: string;

  static toModel(dto: DeepPartial<GetBusinessUnitByPostalCodeRequestDTO>): GetBusinessUnitByPostalCodeRequestModel;
  static toModel(dto: DeepPartial<GetBusinessUnitByPostalCodeRequestDTO> | undefined | null): GetBusinessUnitByPostalCodeRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBusinessUnitByPostalCodeRequestDTO> | undefined | null): GetBusinessUnitByPostalCodeRequestModel | undefined {
    return dto ? new GetBusinessUnitByPostalCodeRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBusinessUnitByPostalCodeRequestModel> | GetBusinessUnitByPostalCodeRequestModel): GetBusinessUnitByPostalCodeRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      postalCode: unwrapped.postalCode,
      postalCodeAddition: unwrapped.postalCodeAddition,
    } as GetBusinessUnitByPostalCodeRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBusinessUnitByPostalCodeRequestModel, can not map to GetBusinessUnitByPostalCodeRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
